import { MouseEventHandler, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/models';

export interface ClickOptions {
  afterLogin?: () => any;
}
export default function useClick<T>(options?: ClickOptions) {
  const { token } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const onClick: MouseEventHandler<T> = useCallback(
    e => {
      if (!token) {
        e.preventDefault();
        dispatch({ type: 'modal/openUserLoginModal', payload: 'login' });
      } else {
        options?.afterLogin?.();
      }
    },
    [dispatch, options, token]
  );
  return {
    onClick,
  };
}
